import Vue from 'vue'
import Vuex from 'vuex'
import dispatch from "@/store/modules/dispatch";
import Courier from "@/store/modules/courier";

Vue.use(Vuex)
let CurrentTime = function () {
    let date = new Date();
    let d = date.toISOString().split('T')[0]
    let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    let t = hour + ':' + minute + 'hrs';
    return d + ` at ` + t;
}
const store = new Vuex.Store({
    state: {
        loading: false,
        isUpdateAvailable: false,
        api: "945ac88d-e88a-11ed-91dd-00163e8d4996",
    },
    getters: {
        getApiKey: (state) => state.api,
        getLoadingState: (state) => state.loading,
        getUpdateAvailability: (state) => state.isUpdateAvailable,
        currentDate: () => {
            let date = new Date();
            return date.toISOString().split('T')[0];
        },

        currentTime: () => {
            let date = new Date();
            let d = date.toISOString().split('T')[0]
            let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
            let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            let t = hour + ':' + minute;
            return d + `T` + t;
        },
    },
    mutations: {
        setLoadingState: (state, payload) => state.loading = payload,
        setUpdateAvailability: (state, payload) => state.isUpdateAvailable = payload,
    },
    actions: {
        async login(context, payload) {
            const url = `${synergyApi}delivery/login`;
            try {
                const response = await context.dispatch('sendRequest', { url, payload });
                // Wrapped-error detection: the backend's Utils.responseFromLocal()
                // returns HTTP 200 with {LocalID, response: {message: "<error>"},
                // processed: true} for the error path. axios does not throw.
                // sendRequest returns data.response as if it were a success.
                // Detect the wrapped-error shape: has .message but lacks .username.
                if (response && typeof response === 'object'
                    && typeof response.message === 'string'
                    && response.username == null) {
                    const synthetic = new Error(response.message);
                    // Shape it like an axios error so errorHandler.loginError
                    // matches it against the body-string regexes.
                    synthetic.response = { status: 200, data: { message: response.message } };
                    throw synthetic;
                }
                return response;
            } catch (err) {
                const { httpStatus, friendlyMessage, rawMessage } = errorHandler.loginError(err);
                const wrapped = new Error(friendlyMessage);
                wrapped.httpStatus = httpStatus;
                wrapped.rawMessage = rawMessage;
                throw wrapped;
            }
        },
        sendRequest(context, {url, payload, headers, method=`post`}) {
            const maxRetries = 3;
            let currentRetry = 0;
            if (!payload.localid){
                payload.localid = generateUUID();
            }

            const attemptRequest = () => {
                return axios[method](url, payload, {
                    headers: headers || {}
                }).then(({data}) => {
                    if (!data.processed) {
                        // Check if the response indicates unprocessed data and if retries are available
                        if (currentRetry < maxRetries) {
                            currentRetry++;
                            console.log(`Attempt ${currentRetry}: Data unprocessed, retrying...`);
                            return attemptRequest(); // Retry the request
                        }
                        // Throw an error if max retries are reached with unprocessed data
                        throw new Error('Data still unprocessed after maximum retries : ' + maxRetries);
                    }
                    return data.response; // Return the response if data is processed
                }).catch(err => {
                    if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
                        if (currentRetry < maxRetries) {
                            currentRetry++;
                            console.log(`Attempt ${currentRetry}: Retrying...`);
                            return attemptRequest(); // Retry the request
                        }
                    }
                    throw err; // Re-throw the error if it's not a timeout or retries are exhausted
                });
            };
            return attemptRequest()
                .then(response => {
                    payload.localid = null;
                    return response
                })
                .catch(err => errorHandler.tomcatError(err));
        }
    },
    modules: {
        dispatch,Courier
    }
})
export default store;